import { array, mixed, number, object, SchemaOf, string, boolean } from 'yup';

import { defaultPeriodValue } from '@/react/edge/edge-stacks/components/RetryDeployPeriod';
import { staggerConfigValidation } from '@/react/edge/edge-stacks/components/StaggerFieldset';
import { relativePathValidation } from '@/react/portainer/gitops/RelativePathFieldset/validation';

import { envVarValidation } from '@@/form-components/EnvironmentVariablesFieldset';

import { Artifact, FormValues } from './type';
import { DeploymentType } from './detectDeploymentType';

function artifactSchema(): SchemaOf<Artifact> {
  return object({
    name: string().required('Name is required.'),
    deploymentType: mixed<DeploymentType>()
      .oneOf(Object.values(DeploymentType))
      .required(),
    files: array(
      object({
        sourceId: number().required('File source is required'),
        path: string().required('File path is required'),
        ref: string().required('Git reference is required'),
      })
    ).length(1, 'File is required'),
    targets: array(number().required()).min(
      1,
      'At least one target is required.'
    ),
    config: object({
      envVars: envVarValidation(),
      prePullImage: boolean().default(false),
      retryDeploy: boolean().default(false),
      retryPeriod: number().default(defaultPeriodValue),
      parallelConfig: staggerConfigValidation(),
      registryId: number(),
      relativePath: relativePathValidation(),
      useManifestNamespaces: boolean().default(false),
    }),
  });
}

export function validationSchema(): SchemaOf<FormValues> {
  return object({
    name: string().required('Name is required.'),
    sources: array(number().required()).min(
      1,
      'At least one source is required.'
    ),
    artifacts: array(artifactSchema()),
  });
}

export function artifactsStepValidationSchema() {
  return object({
    artifacts: array(artifactSchema().pick(['name', 'files'])),
  });
}

export function artifactConfigStepValidationSchema() {
  return validationSchema().pick(['sources', 'artifacts']);
}
